import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import { del } from '@Domain/Api';
import interviewDeleted, {
	type InterviewDeletedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewDeleted';
import interviewDeletionFailed, {
	type InterviewDeletionFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewDeletionFailed';
import type DeleteInterview from '@Application/Beneficiaries/Interviews/Commands/DeleteInterview';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = InterviewDeletedAction | InterviewDeletionFailedAction;

export default (command: DeleteInterview) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			await del<void>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}`,
			);

			const action = interviewDeleted(
				{ interviewId: command.interviewId },
				command.facilityId,
				command.subject.typeKey,
				command.subject.subjectId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = interviewDeletionFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
